import React from 'react';
import { Row, Col, Typography, Button } from 'antd';
import { motion } from 'framer-motion';
import './AboutSection.css';

const { Title, Paragraph } = Typography;

const AboutSection = () => {
  return (
    <div className="about-section" style={{ padding: '50px 0', backgroundColor: '#f0f2f5' }}>
      <Row gutter={[32, 32]} align="middle">
        <Col xs={24} md={12}>
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <img 
              src="https://images.unsplash.com/flagged/photo-1551135049-83f3419ef05c?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mzl8fG1lZXRpbmclMjBjb25zdWx0YW5jeXxlbnwwfHwwfHx8MA%3D%3D" 
              alt="About Prime Healthcare" 
              
              style={{ width: '100%', borderRadius: '8px' }}
            />
          </motion.div>
        </Col>
        <Col xs={24} md={12}>
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <Title level={2}>About Prime Health Care Consultancy</Title>
            <Paragraph>

              We are an independent consultancy firm dedicated to guiding and supporting healthcare providers across Punjab in complying with the standards and regulatory requirements set by the Punjab Health Commission (PHC). Our mission is to make the compliance process smooth, understandable, and achievable for clinics, hospitals, and healthcare centers of all sizes.
            </Paragraph>
            <Paragraph>
              We take pride in handling each case with dedication, confidentiality, and a results-driven approach — ensuring that you are always a step ahead in achieving healthcare excellence and compliance.
            </Paragraph>
            <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
              <a href='/about'> <Button type="primary" size="large">Learn More About Us</Button></a>
            </motion.div>
          </motion.div>
        </Col>
      </Row>
    </div>
  );
};

export default AboutSection;